module.exports = __webpack_public_path__ + "img/product.845666d7.png";